import React from "react";
import  "./LinkInfo.css";
import Modal from "../Modal/Modal";
import RealAux from './../../hoc/RealAux';
import dataServices from "../../common/dataServices";

class LinkInfo extends React.Component {
    
    state= {  
        showModal:false,
        items:[]
    }

    clickModalHandler = () =>{
        this.setState({
                    showModal:true
                })
    }

    closeModal = () =>{
        this.setState({
            showModal:false
        })
    }

    getQuestItems = () =>{
        dataServices.getSPListItems(this.props.siteUrl,'ModQuestList','AllItems')
        .then((response)=> response.data)   
        .then(lsItemsResponse=>{
            var itemsData = JSON.parse(lsItemsResponse);
            this.setState(
                {
                    items: itemsData
                }
            )
            
        });
    }

    componentDidMount = () =>{
        this.getQuestItems();
     }

     
    
    render() {

    let wp ='';
    //let link='';
    let linkTitle='';
        if(!this.props.isQuest)
        {
           // link = this.props.data.ModLinkDetailsLink_Url;
            linkTitle = this.props.data.ModLinkDetailsLink.Text;//this.props.data.ModLinkDetailsLink_Text;//'קרא עוד';
            wp = <a href={this.props.data.ModLinkDetailsLink_Url} title={linkTitle}>
                        <div className="link-text">{linkTitle}</div>
                    <div className="traingle-bottom blue-traingle"></div>
                </a>;
        }
        else
        {
            linkTitle='התחל שאלון';   
            let show= this.state.showModal ? 'show' : '';
            wp = <div>
                    <a onClick={this.clickModalHandler} data-toggle="modal" data-target="#weaponsForm">
                        <div className="link-text">{linkTitle}</div>
                        <div className="traingle-bottom blue-traingle"></div>
                    </a>
                    <Modal showModal={this.state.showModal} close={this.closeModal} items={this.state.items}></Modal>
                </div>;
               
        }
       
    return (
        <div className="col-12 LinkInfoWrap">
            <div className="card">
                <img className="cardBackgroundImg" src={ this.props.data.MOLinkDetailImage.ImageUrl} data-holder-rendered="true" />
                <div className="card-body">
                    <h3 >{this.props.data.Title}</h3>
                    <p className="card-text" dangerouslySetInnerHTML={{__html: this.props.data.ModLinkSubTitle}}></p>
                    <div className="card-icon">
                        <img src={ this.props.data.MOLinkDetailIcon.ImageUrl} data-holder-rendered="true" />
                        <span>{this.props.data.ModLinkIconText}</span>
                    </div>
                </div>
            </div>
            <div className="card-link">
                {wp}
            </div>
        </div>
         
    );
}
}
export default LinkInfo;
